module.exports = __webpack_public_path__ + "img/sketchy.cce6f4f5.png";